import { connect } from "react-redux";
import Component from "../components/AppChartNavigation";
import { nextSlide, prevSlide, goToSlide, setUIVisibilityState } from "../actions";
import findIndex from "lodash/findIndex";
import { isSlideAvailable } from "../utils/helpers";
export var allowNextInExam = function(_state) {
    var interactions = _state.examInteractions;
    var exam = _state.exam;
    if (interactions && exam && interactions[exam.id]) {
        if (exam.position === interactions[exam.id].length - 1) {
            if (!!exam.answers && exam.answers.length === interactions[exam.id].length || _state.nodes.find(function(n) {
                return n.id === exam.id;
            }).allow_navigation) {
                return true;
            } else {
                return false;
            }
        } else {
            return isSlideAvailable(interactions[exam.id][exam.position], _state);
        }
    }
    return false;
};
var mapStateToProps = function(state, ownProps) {
    var slides = state.nodes.filter(function(n) {
        return n.target_type !== "Filter";
    });
    var currentIndex = findIndex(slides, {
        id: state.currentSlide
    });
    var currentExam = state.exam ? state.nodes.find(function(n) {
        return n.id === state.exam.id;
    }) : null;
    return {
        currentSlide: state.currentSlide,
        originSlide: slides.find(function(s) {
            return s.id === state.originSlide;
        }),
        prevVisible: currentIndex > 0 && (!state.exam || state.exam && state.exam.state !== "running") || !!state.exam && state.exam.state === "running" && currentExam.allow_navigation,
        prevAllowed: state.exam && state.exam.state === "running" && state.exam.position > 0 && state.nodes.find(function(n) {
            return n.id === state.exam.id;
        }).allow_navigation || (!state.exam || state.exam && state.exam.state !== "running") && currentIndex > 0 && slides[currentIndex - 1] && isSlideAvailable(slides[currentIndex - 1], state),
        nextVisible: currentIndex < slides.length - 1 && (!state.exam || state.exam && state.exam.state !== "running") || !!state.exam && state.exam.state === "running" && currentExam.allow_navigation,
        nextAllowed: state.exam && state.exam.state === "running" && allowNextInExam(state) || currentIndex < slides.length - 1 && slides[currentIndex + 1] && isSlideAvailable(slides[currentIndex + 1], state),
        allowExamNavigation: currentExam && currentExam.allow_navigation && state.exam.state === "running",
        isLastExamQuestion: currentExam && state.examInteractions && currentExam.allow_navigation && state.exam.state === "running" && state.exam.position === state.examInteractions[state.exam.id].length - 1
    };
};
var mapDispatchToProps = function(dispatch, ownProps) {
    return {
        next: function() {
            dispatch(nextSlide());
        },
        prev: function() {
            dispatch(prevSlide());
        },
        goTo: function(id, localId, origin, quickFavOrigin) {
            dispatch(goToSlide({
                id: id,
                localId: localId,
                origin: origin,
                quickFavOrigin: quickFavOrigin
            }));
        },
        setUIVisibilityState: function(state) {
            return dispatch(setUIVisibilityState({
                state: state
            }));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Component);
